<template>
  <section style="display: none">
    <span class="TopWinnersSection-styles-title">{{ t.top_won_bet }}</span>
    <div class="TopWinnersSection-styles-container">
      <div class="TopWinnersTabSet-styles-top-winners-tabs">
        <button testid="Button_tab_button_0" id="tab-button-0" @click="changePeriod('day')"
                class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width"
                :class="(period === 'day') ? 'TabButton-styles-tab-button-active' :'' "
        >
          <div class="">{{ t.one_day }}</div>
        </button>
        <button testid="Button_tab_button_1" id="tab-button-1" @click="changePeriod('week')"
                :class="(period === 'week') ? 'TabButton-styles-tab-button-active' :'' "
                class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width">
          <div class="">{{ t.one_week }}</div>
        </button>
        <button testid="Button_tab_button_2" @click="changePeriod('month')"
                :class="(period === 'month') ? 'TabButton-styles-tab-button-active' :'' "
                id="tab-button-2" class="Button-styles-button TabButton-styles-tab-button TabButton-styles-tab-button-full-width">
          <div class="">{{ t.one_month }}</div>
        </button>
      </div>
      <div class="TopWinnersList-styles-top-winners-list">
        <div class="TopWinnersList-styles-row TopWinnersList-styles-header">
          <div class="TopWinnersList-styles-header-content"></div>
          <div class="TopWinnersList-styles-header-content">{{ t.betting.title.earnings }}</div>
          <div class="TopWinnersList-styles-header-content">{{ t.betting.title.stake }}</div>
        </div>
        <ul class="TopWinnersList-styles-body" v-for="d in data" @click="getBetDetail(d)">
          <div>
            <div class="TopWinnersItem-styles-row TopWinnersItem-styles-link">
              <div class="TopWinnersItem-styles-content">{{ d.rank }}.</div>
              <div class="TopWinnersItem-styles-content">{{ d.earnings | toMoney(d.currency) }}</div>
              <div class="TopWinnersItem-styles-content">{{ d.amount | toMoney(d.currency) }}</div>
              <img :class="(collapsed === d.id) ? 'TopWinnersItem-styles-open-arrow' : ''" alt="Arrow right" src="/static/assets/img/arrow-right.svg">
            </div>
            <div class="CollapsibleItem-styles-collapsible-item TopWinnersItem-styles-collapsible">
              <div class="">
                <div class="Animation-styles-element" :style="(collapsed === d.id) ? 'height: auto' :''">
                  <div>
                    <div v-show="fetching" class="Spinner-styles-spinner-image TopWinnersItem-styles-loader"></div>
                  </div>
                </div>
                <div v-if="bet && collapsed === d.id" class="Animation-styles-element" style="height: auto;">
                  <li class="MyBetsBetItem-styles-bet MyBetsBetItem-styles-popup" v-for="it in items">
                    <div class="MyBetsBetItem-styles-bet-layout MyBetsBetItem-styles-disable-link">
                      <div class="MyBetsBetItem-styles-bet-market">
                        <span class="MyBetsBetItem-styles-standard-font">{{ it.name }}: </span>
                        <span class="MyBetsBetItem-styles-bet-placed">{{ it.selection }}</span>
                      </div>
                      <div class="MyBetsBetItem-styles-bet-teams MyBetsBetItem-styles-popup-font">{{ it.fcName }} -
                        {{ it.scName }}</div>
                    </div>
                  </li>
                  <div class="TopWinnersItem-styles-bet-footer">
                    <span>{{ bet.bet_count }}x {{ bet.type.name }}</span>
                    <span class="TopWinnersItem-styles-footer-odds">{{ t.betting.title.total_odd }} {{ bet.multiplier }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
    import betDetail from '@/components/user/account/betDetail'
    export default {
        name: "topRewards",
	    components: {betDetail},
        data () {
            return {
              session: session,
              t: this.$root.t,
              data: null,
              betId: null,
              period: 'day',
              collapsed: 0,
              fetching: true,
              bet: null,
              items: null
            }
        },
        watch: {
          'collapsed' () {
              this.fetchBet();
          }
        },
        mounted () {
              this.fetchTable()
        },
        methods: {
            fixScroll () {
                this.fixBodyScroll()
            },
            getBetDetail (d) {

              if(this.collapsed == d.id){
                this.collapsed = 0;
              }else {
                this.collapsed = d.id;
              }
            },
            async fetchBet() {
              this.fetching = true;
              this.$http.get(bsapi + 'api/v1/bet/detail/' + this.collapsed)
                  .then(response => {
                    this.fetching = false;
                    this.bet = response.body.result.bet;
                    this.items = response.body.result.items;
                  }, response => {
                    this.fetching = false;
                  })
            },
            fetchTable () {
                this.$http.get(api+'api/v1/bet/winnings?_=x', {params: {timeperiod: this.period}})
                    .then(response => {
                    // get body data
                    this.data = response.body.result.bets;

                }, response => {
                    // error callback
                })
            },
            changePeriod(p) {
              this.period = p

              this.fetchTable()
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/widget/topRewards.vue